import React from 'react';
import "./FormTable.scss";
var FormTable = function (props) {
    var rows = props.rows, width = props.width;
    return (React.createElement("div", { className: "form-table", style: {
            gridTemplateColumns: "repeat(auto-fit, ".concat(width || "80vw", ")")
        } }, rows.map(function (row) { return (React.createElement("div", { className: "table-row", key: row.id }, row.columns.map(function (column) { return (React.createElement("div", { key: column.accessor, className: "table-cell", style: { backgroundColor: column.bgColor || 'transparent' } }, column.header)); }))); })));
};
export default FormTable;
